import { useUploaderContext } from "./context";

export function useUploaderState() {
  return useUploaderContext();
}
